import { render, staticRenderFns } from "./BlogArticle.vue?vue&type=template&id=22d41da2&scoped=true"
import script from "./BlogArticle.vue?vue&type=script&lang=js"
export * from "./BlogArticle.vue?vue&type=script&lang=js"
import style0 from "./BlogArticle.vue?vue&type=style&index=0&id=22d41da2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d41da2",
  null
  
)

export default component.exports